import React from "react";

const BurgerIconSvg = () => {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 12L2 12"
        stroke="#E0BB1E"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M14 7L2 7"
        stroke="#CFB2FF"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M14 2L2 2"
        stroke="#FFA686"
        strokeWidth="4"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default BurgerIconSvg;
